class BaseError extends Error {
  constructor(message) {
    super(message);
    this.displayName = this.constructor.displayName;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

export class FatalError extends BaseError {
  static displayName = 'FatalError';
}

export class ServerError extends FatalError {
  static displayName = 'ServerError';
}

export class PermissionDeniedError extends FatalError {
  static displayName = 'PermissionDeniedError';
}

export class UnknownUserError extends BaseError {
  static displayName = 'UnknownUserError';
}

export class IpNotAllowed extends FatalError {
  static displayName = 'IpNotAllowed';
}
